export default {
    "logout-success": "로그아웃 성공",
    "logout-error": "로그아웃 실패",
    "confirm": "확인",
    "copySuccess": "복사 성공",
    "server": {
        "selectServer": "서버 선택",
        "serverAmerica": "America",
        "serverEurope": "Europe",
        "serverAsia": "Asia",
        "serverHMT": "HMT",
        "serverSEA": "SEA",
        "noRole": "캐릭터가 없습니다, \n먼저 게임에 접속해주세요",
        "noRole2": "캐릭터가 없습니다",
        "noOtherRole": "다른 캐릭터를 찾을 수 없어 교체를 진행할 수 없습니다."
    },
    "uidlogin": { 
        "enterCode": "코드를 입력하세요",
        "enterCode2": "올바른 코드를 입력하세요",
        "sendCode": "코드 전송",
        "agree": "이용 약관과 개인정보 처리 방침을 읽고 동의하세요",
        "sended": "전송됨",
        "tipUid": "UID를 입력하세요",
        "tipUid2": "올바른 UID를 입력하세요",
        "login": "로그인",
        "loginFail": "로그인에 실패했습니다. UID와 코드를 확인하세요",
        "loginSuccess": "로그인 성공",
        "sendFail": "역할을 찾을 수 없습니다",
        "sendFail2": "전송 실패",
        "sendFast": "전송 너무 빠름",
        "sendFast2": "전송 너무 빠름, {time} 후에 다시 시도하세요",
        "codeInvaild": "코드가 유효하지 않습니다"
    },
    "share-tips": "길게 눌러 이미지를 저장하세요"
};
